export default __webpack_public_path__ + "static/instantChatBg2-439256eb781e2828a8997b947ea78b2a.png";